import { BillOfQuantitesModel } from './../models/offer/billOfQuantitiesModel';
import { FittingsModel } from './../models/offerSteps/fittingsModel';
import { ProductToProductModel } from './../models/product/productToProductModel';
import { CategoryType } from './../common/enums';
import { IProduct, ICategory } from './../common/appDatabase';
import { OfferStepModel } from './../models/offer/offerStepModel';
import * as HelperFunctions from '../common/functions/helperFunctions';
import XLSX from 'xlsx';
import { Units } from '../common/enums';
import Translate from '../common/functions/translate';
import { ProductLiteModel } from '../models/product/productLiteModel';
import LocalProductsService from './localDataServices/localProductsService';
import LocalCategoryService from './localDataServices/localCategoryService';

export default class GenerateXlxsService {
    localProductsService = new LocalProductsService();
    localCategoryService = new LocalCategoryService();

    dbCategories = new Array<ICategory>(0);
    dbProducts = new Array<IProduct>(0);
    offer: OfferStepModel | null = null;

    generateBillOfQuantities = (offer: OfferStepModel) => {
        this.offer = offer;

        return new Promise((resolve, reject) => {
            let result = new BillOfQuantitesModel();
            if (offer.gasInstallation || offer.heathInstall) {
                if (offer.gasInstallation.products || offer.gasInstallation.additionalProducts || (offer.heathInstall && offer.heathInstall.products) || (offer.heathInstall && offer.heathInstall.additionalProducts)) {
                    this.localProductsService.getAllProducts().then(
                        (products: any) => {
                            this.dbProducts = products;

                            this.localCategoryService.getAllCategories().then(
                                (categories: any) => {
                                    this.dbCategories = categories;

                                    result.devicesAndMaterials = this.generateBillOfQuantitiesDevicesAndMaterials(offer);
                                    result.labor = this.generateBillOfQuantitiesLabor(offer);

                                    resolve(result);
                                }
                            ).catch(error => {
                                console.log(error);
                                resolve(result);
                            })
                        }
                    ).catch(error => {
                        console.log(error);
                        resolve(result);
                    })
                } else {
                    resolve(result);
                }
            } else {
                resolve(result);
            }
        })

    }

    private generateBillOfQuantitiesLabor(offer: OfferStepModel): string {
        let gasProducts = new Array<BillProduct>(0);
        let heatProducts = new Array<BillProduct>(0);

        let gasProductsXls = new Array<XlsBillProduct>(0);
        let heatProductsXls = new Array<XlsBillProduct>(0);

        if (offer.gasInstallation) {
            if (offer.gasInstallation.products) {
                let gasMainProducts = this.getBillProducts(offer.gasInstallation.products, true);

                if (gasMainProducts) {
                    gasProducts = gasProducts.concat(gasMainProducts);
                }
            }

            if (offer.gasInstallation.additionalProducts) {
                let productsToCheck = offer.gasInstallation.additionalProducts.filter(p => p.addedFromPlanner === false);

                let gasAdditionalProducts = this.getBillProducts(productsToCheck, true);

                if (gasAdditionalProducts) {
                    gasProducts = gasProducts.concat(gasAdditionalProducts);
                }
            }
        }

        if (offer.heathInstall) {
            if (offer.heathInstall.products) {
                let heatMainProducts = this.getBillProducts(offer.heathInstall.products, true);

                if (heatMainProducts) {
                    heatProducts = heatProducts.concat(heatMainProducts);
                }
            }

            if (offer.heathInstall.additionalProducts) {
                let productsToCheck = offer.heathInstall.additionalProducts.filter(p => p.addedFromPlanner === false);

                let heatAdditionalProducts = this.getBillProducts(productsToCheck, true);

                if (heatAdditionalProducts) {
                    heatProducts = heatProducts.concat(heatAdditionalProducts);
                }
            }
        }


        // Remove duplicate products
        let gasProductsDistinct = new Array<BillProduct>(0);
        let heatProductsDistinct = new Array<BillProduct>(0);

        gasProducts.forEach(gasProduct => {
            let foundProduct = gasProductsDistinct.find(p => p.productId === gasProduct.productId);

            if (foundProduct) {
                foundProduct.qty += gasProduct.qty;
            } else {
                gasProductsDistinct.push(gasProduct);
            }
        });

        if (heatProducts) {
            heatProducts.forEach(heatProduct => {
                let foundProduct = heatProductsDistinct.find(p => p.productId === heatProduct.productId);

                if (foundProduct) {
                    foundProduct.qty += heatProduct.qty;
                } else {
                    heatProductsDistinct.push(heatProduct);
                }
            })
        }
        // End remove duplicate products

        //let index = 1;
        gasProductsDistinct.forEach(gasProduct => {
            gasProductsXls.push(
                {
                    artNo: gasProduct.artNo,
                    name: gasProduct.name,
                    unit: gasProduct.unit,
                    qty: gasProduct.qty,
                    executedQty: '',
                    supplier: gasProduct.supplier,
                    notes: '',
                });
            //index++;
        });

        //index = 1;
        heatProductsDistinct.forEach(heatProduct => {
            heatProductsXls.push(
                {
                    artNo: heatProduct.artNo,
                    name: heatProduct.name,
                    unit: heatProduct.unit,
                    qty: heatProduct.qty,
                    executedQty: '',
                    supplier: heatProduct.supplier,
                    notes: ''
                });
        });

        if (gasProductsXls.length > 0 || heatProductsXls.length > 0) {
            let xlxs = this.createBillOfQuantitiesXlsx(gasProductsXls, heatProductsXls, true);
            return xlxs;
        } else {
            return '';
        }
    }

    private generateBillOfQuantitiesDevicesAndMaterials(offer: OfferStepModel): string {
        let gasProductsXls = new Array<XlsBillProduct>(0);
        let heatProductsXls = new Array<XlsBillProduct>(0);

        let gasProducts = this.getBillProducts(offer.gasInstallation.products, false);

        if (offer.gasInstallation.additionalProducts) {
            let productsToCheck = offer.gasInstallation.additionalProducts.filter(p => p.addedFromPlanner === false);

            let gasAdditionalProducts = this.getBillProducts(productsToCheck, false);

            if (gasAdditionalProducts && gasAdditionalProducts.length > 0) {
                gasProducts = gasProducts.concat(gasAdditionalProducts);
            }
        }

        let heatProducts = this.getBillProducts(offer.heathInstall.products, false);

        if (offer.heathInstall.additionalProducts) {
            let productsToCheck = offer.heathInstall.additionalProducts.filter(p => p.addedFromPlanner === false);

            let heatAdditionalProducts = this.getBillProducts(productsToCheck, false);

            if (heatAdditionalProducts && heatAdditionalProducts.length > 0) {
                heatProducts = heatProducts.concat(heatAdditionalProducts);
            }
        }

        if (gasProducts.length === 0 && heatProducts.length === 0) {
            return '';
        }

        // Remove duplicate products
        let gasProductsDistinct = new Array<BillProduct>(0);
        let heatProductsDistinct = new Array<BillProduct>(0);

        gasProducts.forEach(gasProduct => {
            let foundProduct = gasProductsDistinct.find(p => p.productId === gasProduct.productId);

            if (foundProduct) {
                foundProduct.qty += gasProduct.qty;
            } else {
                gasProductsDistinct.push(gasProduct);
            }
        });

        if (heatProducts) {
            heatProducts.forEach(heatProduct => {
                let foundProduct = heatProductsDistinct.find(p => p.productId === heatProduct.productId);

                if (foundProduct) {
                    foundProduct.qty += heatProduct.qty;
                } else {
                    heatProductsDistinct.push(heatProduct);
                }
            })
        }
        // End remove duplicate products

        // Add gas pipes
        let gasPipes = new Array<any>();

        if (offer.gasInstallation.pipeInfo && offer.gasInstallation.pipeInfo.pipes) {
            offer.gasInstallation.pipeInfo.pipes.forEach(pipe => {
                if (pipe.productId) {
                    let pipeProduct = this.dbProducts.find(p => p.remoteId === pipe.productId);

                    if (pipeProduct) {
                        let gasPipe = gasPipes.find(p => p.productId === pipeProduct?.remoteId);

                        if (gasPipe) {
                            gasPipe.length += pipe.pipeLength
                        } else {
                            gasPipes.push({
                                artNo: pipeProduct.articleNumber,
                                productId: pipeProduct.remoteId,
                                name: pipeProduct.article,
                                length: pipe.pipeLength,
                                notes: '',
                                diameter: pipeProduct.diameter,
                                isUnderground: pipe.isUnderground,
                                price: pipeProduct.price,
                                priceFromSupplier: pipeProduct.priceFromSupplier,
                                supplier: pipeProduct.supplier,
                            });
                        }
                    }
                } else {
                    if (!pipe.isUnderground) {
                        let foundPipe = gasPipes.find(p => p.diameter === pipe.diameter && p.isUnderground === false && p.productId === 0);

                        if (foundPipe) {
                            foundPipe.length += pipe.pipeLength
                        } else {
                            let pipeName = Translate('copper pipes');

                            if (pipe.diameter) {
                                pipeName += ` ф ${pipe.diameter}x${pipe.diameter < 28 ? '1' : '1.5'} mm*`;
                            } else {
                                pipeName += '*';
                            }

                            gasPipes.push({
                                artNo: '',
                                productId: 0,
                                name: pipeName,
                                length: pipe.pipeLength,
                                notes: Translate('BDS'),
                                diameter: pipe.diameter,
                                isUnderground: false,
                                price: 0.00,
                                priceFromSupplier: 0.00,
                                supplier: ''
                            });
                        }
                    } else {
                        let foundPipe = gasPipes.find(p => p.isUnderground === true);

                        if (foundPipe) {
                            foundPipe.length += pipe.pipeLength;
                        } else {
                            gasPipes.push({
                                artNo: '',
                                productId: 0,
                                name: `${Translate('underground pipes')}*`,
                                length: pipe.pipeLength, notes: '',
                                diameter: pipe.diameter,
                                isUnderground: true,
                                price: 0.00,
                                priceFromSupplier: 0.00,
                                supplier: ''
                            });
                        }
                    }
                }
            });
        }

        //Add heat pipes
        let heatPipes = new Array<any>();

        if (offer.heathInstall && offer.heathInstall.pipeInfo && offer.heathInstall.pipeInfo.pipes) {
            offer.heathInstall.pipeInfo.pipes.forEach(pipe => {
                if (pipe.productId) {
                    let pipeProduct = this.dbProducts.find(p => p.remoteId === pipe.productId);

                    if (pipeProduct) {
                        let heatPipe = heatPipes.find(p => p.productId === pipeProduct?.remoteId);

                        if (heatPipe) {
                            heatPipe.length += pipe.pipeLength
                        } else {
                            heatPipes.push({
                                artNo: pipeProduct.articleNumber,
                                productId: pipeProduct.remoteId,
                                name: pipeProduct.article,
                                length: pipe.pipeLength,
                                notes: '',
                                diameter: pipeProduct.diameter,
                                price: pipeProduct.price,
                                priceFromSupplier: pipeProduct.priceFromSupplier,
                                supplier: pipeProduct.supplier,
                            });
                        }
                    }
                } else {
                    let foundPipe = heatPipes.find(p => p.diameter === pipe.diameter && p.productId === 0);

                    if (foundPipe) {
                        foundPipe.length += pipe.pipeLength
                    } else {
                        heatPipes.push({
                            artNo: '',
                            productId: 0,
                            name: `${Translate('polyethylene pipes with aluminum insert')}*`,
                            length: pipe.pipeLength,
                            notes: '',
                            diameter: pipe.diameter,
                            price: 0.00,
                            priceFromSupplier: 0.00,
                            supplier: ''
                        });
                    }
                }
            });
        }

        //Add fittings
        if (offer.gasInstallation.fittings) {
            this.addFittings(offer.gasInstallation.fittings, gasProductsDistinct);
        }

        if (offer.heathInstall.fittings) {
            this.addFittings(offer.heathInstall.fittings, heatProductsDistinct);
        }

        //let index = 1;
        gasProductsDistinct.forEach(gasProduct => {
            gasProductsXls.push({
                artNo: gasProduct.artNo,
                name: gasProduct.name,
                unit: gasProduct.unit,
                qty: gasProduct.qty,
                executedQty: '',
                supplier: gasProduct.supplier,
                notes: ''
            });
            //index++;
        });

        gasPipes.forEach(gasPipe => {
            let lenghtRound = Math.ceil(gasPipe.length / 100);
            gasProductsXls.push({
                artNo: gasPipe.artNo,
                name: gasPipe.name,
                unit: Translate('UnitLinearMeter'),
                qty: lenghtRound,
                executedQty: '',
                supplier: gasPipe.supplier,
                notes: gasPipe.notes
            });
            //index++
        })

        if (heatProductsDistinct) {
            //index = 1;
            heatProductsDistinct.forEach(heatProduct => {
                heatProductsXls.push(
                    {
                        artNo: heatProduct.artNo,
                        name: heatProduct.name,
                        unit: heatProduct.unit,
                        qty: heatProduct.qty,
                        executedQty: '',
                        supplier: heatProduct.supplier,
                        notes: ''
                    });
                //index++
            });

            heatPipes.forEach(heatPipe => {
                let lenghtRound = Math.ceil(heatPipe.length / 100);
                heatProductsXls.push(
                    {
                        artNo: heatPipe.artNo,
                        name: heatPipe.name,
                        unit: Translate('UnitLinearMeter'),
                        qty: lenghtRound,
                        executedQty: '',
                        supplier: heatPipe.supplier,
                        notes: heatPipe.notes
                    });
                //index++
            })
        }

        if (gasProductsXls.length > 0 || heatProductsXls.length > 0) {
            let xlxs = this.createBillOfQuantitiesXlsx(gasProductsXls, heatProductsXls, false);
            return xlxs;
        } else {
            return '';
        }

    }

    private getBillProducts(installationProducts: Array<ProductLiteModel>, laborOnly: boolean): Array<BillProduct> {
        let billProducts = new Array<BillProduct>(0);

        if (installationProducts) {

            installationProducts.forEach(product => {
                let dbProduct = this.dbProducts.find(p => p.remoteId === product.productId);

                if (dbProduct) {
                    let categoryType = this.getProductCategoryType(dbProduct.categoryId);

                    if (categoryType === CategoryType.Packages) {
                        let packageBillProducts = this.getBillProductsFromPackage(dbProduct, laborOnly);

                        if (packageBillProducts) {
                            billProducts = billProducts.concat(packageBillProducts);
                        }
                    } else if (categoryType === CategoryType.Services || categoryType === CategoryType.Kits) {
                        if (dbProduct.relatedProducts) {
                            dbProduct.relatedProducts.forEach(relatedProduct => {
                                let bps = this.getBillProductsFormRelatedProduct(relatedProduct, null, laborOnly);

                                if (bps) {
                                    bps.forEach(p => {
                                        p.qty = p.qty * (product.billQuantity ? product.billQuantity : product.quantity);
                                    });

                                    billProducts = billProducts.concat(bps);
                                }
                            })
                        }
                    } else {
                        if (dbProduct.relatedProducts) {
                            dbProduct.relatedProducts.forEach(relatedProduct => {
                                let bp = this.getBillProductsFormRelatedProduct(relatedProduct, null, laborOnly);

                                if (bp) {
                                    let relatedProductCategoryType = this.getProductCategoryType(relatedProduct.relatedProduct.categoryId);

                                    if (relatedProductCategoryType === CategoryType.Services) {
                                        bp.forEach(p => p.qty = p.qty * (product.billQuantity ? product.billQuantity : product.quantity));
                                    }

                                    billProducts = billProducts.concat(bp);
                                }
                            })
                        }

                        if ((!laborOnly && categoryType !== CategoryType.Labor) || (laborOnly && categoryType === CategoryType.Labor)) {
                            let billProduct = this.createBillProduct(product.productId, product.articleNumber, product.article, product.quantity, product.unitId, dbProduct.supplier);
                            billProducts.push(billProduct);
                        }
                    }
                }
            });
        }

        return billProducts;
    }

    private getBillProductsFromPackage(product: IProduct, laborOnly: boolean): Array<BillProduct> {
        let packageBillProducts = new Array<BillProduct>(0);

        if (product.relatedProducts) {
            product.relatedProducts.forEach(relatedProduct => {
                let billProducts = this.getBillProductsFormRelatedProduct(relatedProduct, null, laborOnly);

                if (billProducts) {
                    packageBillProducts = packageBillProducts.concat(billProducts);
                }
            })
        }

        return packageBillProducts;
    }

    private getBillProductsFormRelatedProduct(relatedProduct: ProductToProductModel, parentRelatedProduct: ProductToProductModel | null, laborOnly: boolean): Array<BillProduct> {
        let billProducts = new Array<BillProduct>(0);

        let parentCount = 1;

        if (parentRelatedProduct) {
            parentCount = parentRelatedProduct.count;
        }

        let categoryTypeId = this.getProductCategoryType(relatedProduct.relatedProduct.categoryId);

        if (categoryTypeId !== CategoryType.Services && categoryTypeId !== CategoryType.GasInstallation && categoryTypeId !== CategoryType.HeatInstallation) {
            if ((!laborOnly && categoryTypeId !== CategoryType.Labor && categoryTypeId !== CategoryType.Pipes) || (laborOnly && categoryTypeId === CategoryType.Labor)) {
                let billProduct = this.createBillProduct(relatedProduct.relatedProduct.productId, relatedProduct.relatedProduct.articleNumber, relatedProduct.relatedProduct.article, relatedProduct.count * parentCount, relatedProduct.relatedProduct.unitId, relatedProduct.relatedProduct.supplier);
                billProducts.push(billProduct);
            }
        }

        let dbProduct = this.dbProducts.find(p => p.remoteId === relatedProduct.relatedProductId);

        if (dbProduct && dbProduct.relatedProducts) {
            dbProduct.relatedProducts.forEach(rp => {
                let bps = this.getBillProductsFormRelatedProduct(rp, relatedProduct, laborOnly);

                if (bps) {
                    billProducts = billProducts.concat(bps);
                }
            });
        }

        return billProducts;
    }


    private getProductCategoryType(productCategoryId: number) {
        let category = this.dbCategories.find(c => c.remoteId === productCategoryId);

        if (category) {
            if (category.categoryTypeId) {
                return category.categoryTypeId;
            } else {
                let categoryTypeId = 0;
                let currentCategory: ICategory | undefined = category;

                while (categoryTypeId === 0) {
                    // eslint-disable-next-line
                    currentCategory = this.dbCategories.find(c => c.remoteId === currentCategory!.parentId);

                    if (currentCategory) {
                        categoryTypeId = currentCategory.categoryTypeId;

                        if (!currentCategory.parentId) {
                            break;
                        }
                    } else {
                        break;
                    }
                }

                return categoryTypeId;
            }
        }

        return 0;
    }

    private createBillProduct(productId: number, artNo: string, name: string, count: number, unitId: number, supplier: string): BillProduct {
        let billProduct = new BillProduct();
        billProduct.productId = productId;
        billProduct.artNo = artNo;
        billProduct.name = name;
        billProduct.qty = count;
        billProduct.unit = HelperFunctions.getEnumLabel(unitId, Units, true);
        billProduct.supplier = supplier;

        return billProduct;
    }

    private addFittings(fittings: FittingsModel, products: Array<BillProduct>) {
        if (fittings.autoFittings) {
            let autoFittings = new Array<BillProduct>(0);

            fittings.autoFittings.forEach(fitting => {
                if (fitting.remoteId) {
                    let dbProduct = this.dbProducts.find(p => p.remoteId === fitting.remoteId);

                    if (dbProduct) {
                        let addedFitting = autoFittings.find(f => f.productId === dbProduct?.remoteId);

                        if (addedFitting) {
                            addedFitting.qty++;
                        } else {
                            let billProduct = this.createBillProduct(dbProduct.remoteId, dbProduct.articleNumber, dbProduct.article, 1, dbProduct.unitId, dbProduct.supplier);
                            autoFittings.push(billProduct)
                        }
                    }
                } else {
                    if (fitting.diameter) {
                        let addedFitting = autoFittings.find(f => f.name === `${Translate(fitting.article)} d${fitting.diameter}*`);

                        if (addedFitting) {
                            addedFitting.qty++;
                        } else {
                            let billProduct = this.createBillProduct(0, '', `${Translate(fitting.article)} d${fitting.diameter}*`, 1, Units.UnitNumber, '');
                            autoFittings.push(billProduct)
                        }

                    } else {
                        if (fitting.article === Translate('Elbow')) {
                            fittings.elbowCount++;
                        }

                        if (fitting.article === Translate('Triple')) {
                            fittings.tripleCount++;
                        }
                    }
                }
            });

            if (autoFittings.length > 0) {
                products.push(...autoFittings);
            }
        }


        if (fittings.couplingCount) {
            products.push({ artNo: '', name: Translate('Coupling') + '*', qty: fittings.couplingCount, unit: Translate('UnitNumber'), productId: 0, supplier: '' });
        }

        if (fittings.elbowCount) {
            products.push({ artNo: '', name: Translate('Elbow') + '*', qty: fittings.elbowCount, unit: Translate('UnitNumber'), productId: 0, supplier: '' });
        }

        if (fittings.holenderCount) {
            products.push({ artNo: '', name: Translate('Transitional Holender') + '*', qty: fittings.holenderCount, unit: Translate('UnitNumber'), productId: 0, supplier: '' });
        }

        if (fittings.magnetVentilsCount) {
            products.push({ artNo: '', name: Translate('Magnet Ventil') + '*', qty: fittings.magnetVentilsCount, unit: Translate('UnitNumber'), productId: 0, supplier: '' });
        }

        if (fittings.nipelCount) {
            products.push({ artNo: '', name: Translate('Nipel') + '*', qty: fittings.nipelCount, unit: Translate('UnitNumber'), productId: 0, supplier: '' });
        }

        if (fittings.tripleCount) {
            products.push({ artNo: '', name: Translate('Triple') + '*', qty: fittings.tripleCount, unit: Translate('UnitNumber'), productId: 0, supplier: '' });
        }

        if (fittings.ventilCount) {
            products.push({ artNo: '', name: Translate('Ventil') + '*', qty: fittings.ventilCount, unit: Translate('UnitNumber'), productId: 0, supplier: '' });
        }
    }

    private createBillOfQuantitiesXlsx(gasProductsXls: Array<XlsBillProduct>, heatProductsXls: Array<XlsBillProduct>, isLabor: boolean): string {
        //console.log(heatProductsXls);
        var heading = [[
            Translate('Article No'),
            Translate('Naming'),
            Translate('Measure'),
            Translate('Quantity Short'),
            Translate('Executed Quantity Short'),
            Translate('Supplier'),
            Translate('Note')
        ]];

        let wb = XLSX.utils.book_new();
        wb.Props = {
            Title: !isLabor ? Translate('Bill of quantities') : Translate('Bill of quantities labor'),
            Subject: !isLabor ? Translate('Bill of quantities') : Translate('Bill of quantities labor'),
            CreatedDate: new Date()
        }

        var wscols = [
            { wch: 14 },
            { wch: 70 },
            { wch: 10 },
            { wch: 7 },
            { wch: 15 },
            { wch: 25 },
            { wch: 25 }
        ];

        wb.SheetNames.push(!isLabor ? Translate('Bill of quantities') : Translate('Bill of quantities labor'));

        let ws = XLSX.utils.aoa_to_sheet([['', !isLabor ? Translate('Request for materials') : Translate('Request for installation services'), '', '']]);

        let offset = 2;

        XLSX.utils.sheet_add_aoa(ws, [['', '', '', '', '']], { origin: `A${offset++}` });

        XLSX.utils.sheet_add_aoa(ws, [['', `${Translate('Request Num')}:`, '', '', '', '']], { origin: `A${offset++}` });
        XLSX.utils.sheet_add_aoa(ws, [['', `${Translate('Contract Num')}: ${this.offer?.offerNumber}`, '', '', '', '']], { origin: `A${offset++}` });
        XLSX.utils.sheet_add_aoa(ws, [['', `${Translate('Client')}: ${this.offer?.clientData.name}`, '', '', '', '']], { origin: `A${offset++}` });
        XLSX.utils.sheet_add_aoa(ws, [['', `${Translate('Request date')}:`, '', '', '', '']], { origin: `A${offset++}` });
        XLSX.utils.sheet_add_aoa(ws, [['', `${Translate('Montage address')}: ${this.offer?.clientData.town ? this.offer.clientData.town + ', ' : ''} ${this.offer?.clientData.address ? this.offer?.clientData.address : ''}`, '', '', '', '']], { origin: `A${offset++}` });
        if (!isLabor) { XLSX.utils.sheet_add_aoa(ws, [['', `${Translate('Delivery address')}:`, '', '', '', '']], { origin: `A${offset++}` }) };
        XLSX.utils.sheet_add_aoa(ws, [['', `${Translate('Montage term')}:`, '', '', '', '']], { origin: `A${offset++}` });
        XLSX.utils.sheet_add_aoa(ws, [['', `${Translate('Receiver name')}: ${this.offer?.clientData.name}`, '', '', '', '']], { origin: `A${offset++}` })
        XLSX.utils.sheet_add_aoa(ws, [['', `${Translate('Contact phone')}: ${this.offer?.clientData.phone ? this.offer?.clientData.phone : ''}`, '', '', '', '']], { origin: `A${offset++}` });
        XLSX.utils.sheet_add_aoa(ws, [['', `${Translate('Special client requirements')}:`, '', '', '', '']], { origin: `A${offset++}` });

        XLSX.utils.sheet_add_aoa(ws, [['', '', '', '', '', '']], { origin: `A${offset++}` })


        XLSX.utils.sheet_add_aoa(ws, [['', Translate('GasInstallation').toUpperCase(), '', '', '']], { origin: `A${offset++}` });
        XLSX.utils.sheet_add_aoa(ws, [['', '', '', '', '', '']], { origin: `A${offset++}` })

        XLSX.utils.sheet_add_aoa(ws, heading, { origin: `A${offset++}` })
        XLSX.utils.sheet_add_json(ws, gasProductsXls, { skipHeader: true, origin: `A${offset++}` });

        if (heatProductsXls.length > 0) {
            XLSX.utils.sheet_add_aoa(ws, [['', Translate('HeatingInstallation').toUpperCase(), '', '', '']], { origin: `A${offset + gasProductsXls.length + 1}` })
            XLSX.utils.sheet_add_aoa(ws, [['', '', '', '', '', '']], { origin: `A${offset + gasProductsXls.length + 2}` })
            XLSX.utils.sheet_add_aoa(ws, heading, { origin: `A${offset + gasProductsXls.length + 3}` })
            XLSX.utils.sheet_add_json(ws, heatProductsXls, { skipHeader: true, origin: `A${offset + gasProductsXls.length + 4}` });
        }

        ws['!cols'] = wscols;

        // let E = XLSX.utils.decode_col('E');
        // let E_fmt = "0.00";
        // let E_range = XLSX.utils.decode_range(ws["!ref"]!);
        // for (var i = E_range.s.r + 1; i <= E_range.e.r; ++i) {
        //     var ref = XLSX.utils.encode_cell({ r: i, c: E });
        //     if (!ws[ref]) continue;
        //     if (ws[ref].t !== 'n') continue;
        //     ws[ref].z = E_fmt;
        // }

        // let F = XLSX.utils.decode_col('F');
        // let F_fmt = "0.00";
        // let F_range = XLSX.utils.decode_range(ws["!ref"]!);
        // // eslint-disable-next-line
        // for (var i = F_range.s.r + 1; i <= F_range.e.r; ++i) {
        //     // eslint-disable-next-line
        //     var ref = XLSX.utils.encode_cell({ r: i, c: F });
        //     if (!ws[ref]) continue;
        //     if (ws[ref].t !== 'n') continue;
        //     ws[ref].z = F_fmt;
        // }

        wb.Sheets[!isLabor ? Translate('Bill of quantities') : Translate('Bill of quantities labor')] = ws;

        let wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'base64' });

        return wbout;
    }
}

class BillProduct {
    public productId: number;
    public artNo: string
    public name: string;
    public unit: string;
    public qty: number;
    public supplier: string;
}

class XlsBillProduct {
    public artNo: string;
    public name: string;
    public unit: string;
    public qty: number;
    public executedQty: string;
    public supplier: string;
    public notes: string;

}